import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Settings: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Automatically redirect to the Profile page with Settings tab
    navigate('/profile', { state: { activeTab: 'settings' } });
  }, [navigate]);

  return (
    <div className="max-w-4xl mx-auto text-center py-12">
      <h1 className="text-3xl font-bold mb-6">Settings</h1>
      <p className="text-textMuted mb-4">
        Settings have been moved to the Profile page.
      </p>
      <p className="text-textMuted mb-6">
        Redirecting you to the new location...
      </p>
      <button 
        onClick={() => navigate('/profile')}
        className="bg-accent hover:bg-yellow-500 text-primary font-medium px-6 py-2 rounded-lg transition-colors"
      >
        Go to Profile Settings
      </button>
    </div>
  );
};

export default Settings;
